import React, { Component } from "react";
import "./content.css";
import { connect } from "react-redux";
import lock from "../../assets/img/locks.png";
import * as exerciseService from "../../services/exercise";
import { Button, Card } from "react-bootstrap";
import { useParams } from "react-router-dom";
import ReactPlayer from "react-player";
import Vimeo from "@u-wave/react-vimeo";
import ReactHlsPlayer from "react-hls-player";

import toastr from "toastr";
import FooterInfo from "../footer/footerInfo";
import Footer from "../footer/footer";
import Header from "../header/header";
class EjercicioInfo extends Component {
	constructor(props) {
		super(props);
		this.state = {
			ejercicio: null,
		};
	}
	componentDidMount() {
		let { id } = this.props.params;
		exerciseService.getToken().then((res) => {
			document.getElementById("loading").style.display = "block";
			exerciseService.getExercises(`exerciseids=[${id}]`).then((res) => {
				var exercise = [];
				document.getElementById("loading").style.display = "none";
				for (const key in res.data.exercises) {
					if (Object.hasOwnProperty.call(res.data.exercises, key)) {
						exercise.push(res.data.exercises[key]);
					}
				}
				this.setState({ ejercicio: exercise[0] });
			});
		});
	}
	async copyLink() {
		const text =
			window.location.origin +
			"/ejercicios/#/ejercicio/" +
			this.state.ejercicio.Exercise_Id;
		await navigator.clipboard.writeText(text);
		toastr.clear();
		toastr.options = {
			showDuration: "300",
			hideDuration: "1000",
			timeOut: "5000",
			extendedTimeOut: "1000",
			showEasing: "swing",
			hideEasing: "linear",
			showMethod: "fadeIn",
			hideMethod: "fadeOut",
		};
		toastr.success("Enlace copiado en el portapapeles");
	}
	shareLink() {
		const text =
			window.location.origin +
			"/ejercicios/#/ejercicio/" +
			this.state.ejercicio.Exercise_Id;
		navigator.share({ url: text });
	}

	render() {
		return (
			<>
				<Header />
				<div>
					<div className='loading' id='loading'>
						<div className='uil-ring-css' style={{ transform: "scale(0.79)" }}>
							<div></div>
						</div>
					</div>
					{this.state.ejercicio ? (
						<div
							className='container'
							style={{ marginTop: "10rem", marginBottom: "3rem" }}
						>
							<div className='row'>
								<div className='col-12 col-lg-6'>
									<div>
										<ReactHlsPlayer
											src={this.state.ejercicio.video_src}
											autoPlay={false}
											controls={true}
											width='100%'
											height='auto'
										/>
									</div>
									<div
										className='row'
										style={{ justifyContent: "center", padding: "0px 15px" }}
									>
										{this.state.ejercicio.Larg_Img_1 &&
										this.state.ejercicio.Larg_Img_1.includes("images") ? (
											<img
												src={this.state.ejercicio.Larg_Img_1}
												alt='exercice_1'
												className='exercice_image'
												style={{ paddingLeft: "0px", paddingRight: ".2rem" }}
											></img>
										) : null}
										{this.state.ejercicio.Larg_Img_2 &&
										this.state.ejercicio.Larg_Img_2.includes("images") ? (
											<img
												src={this.state.ejercicio.Larg_Img_2}
												alt='exercice_2'
												className='exercice_image'
												style={{ paddingRight: "0px", paddingLeft: ".2rem" }}
											></img>
										) : null}
									</div>
								</div>

								<div className='col-12 col-lg-6'>
									<h4 style={{ margin: "1rem 0px" }}>
										{this.state.ejercicio.Exercise_Name_Complete}
									</h4>
									<Card.Subtitle
										className='mb-2 text-muted'
										style={{ textTransform: "capitalize" }}
									>
										<b>Músculo:</b> {this.state.ejercicio.Target_Muscle_Group}
									</Card.Subtitle>
									<Card.Subtitle
										className=' text-muted'
										style={{
											textTransform: "capitalize",
											marginBottom: "1rem",
										}}
									>
										<b>Implementos:</b>{" "}
										{this.state.ejercicio.Apparatus_Groups_Name}
									</Card.Subtitle>

									<div style={{ marginTop: "1rem" }}>
										<h6>Preparación</h6>
										<p>{this.state.ejercicio.Instructions_Preparation}</p>
									</div>
									<div>
										<h6>Ejecución</h6>
										<p>{this.state.ejercicio.Instructions_Execution}</p>
									</div>
									<div
										style={{ display: "flex", justifyContent: "space-between" }}
									>
										<div className='copyLink' onClick={() => this.copyLink()}>
											<i className='fas fa-link'></i> Copiar enlace
										</div>
										<div className='copyLink' onClick={() => this.shareLink()}>
											<i className='fas fa-share-alt'></i> Compartir ejercicio
										</div>
									</div>
								</div>
							</div>
							<div style={{ display: "flex", justifyContent: "center" }}>
								<a
									href='https://fullmusculo.com/ejercicios'
									style={{
										color: "#355577",
										textTransform: "uppercase",
										fontWeight: "bold",
										padding: "1rem 3rem",
										marginTop: "3rem",
										textDecoration: "underline",
										textAlign: "center",
										fontSize: "16px",
									}}
								>
									Volver a todos los ejercicios
								</a>
							</div>
						</div>
					) : (
						<></>
					)}
					<FooterInfo />
				</div>
				<Footer />
			</>
		);
	}
}

function withParams(Component) {
	return (props) => <Component {...props} params={useParams()} />;
}
const mapStateToProps = (state) => ({
	userRestricId: state.userRestricId,
});
const mapDispatchToProps = (dispatch) => ({});
export default connect(
	mapStateToProps,
	mapDispatchToProps
)(withParams(EjercicioInfo));
